import { shapeName, ShapesTab } from './ShapesTab'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { TLShape, track } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { FontStylesPanel } from './components/FontStylesPanel/FontStylesPanel'
import { FontFamilyPanel } from './components/FontFamilyPanel/FontFamilyPanel'
import { useRootStore } from 'stores/RootStore'
import { ColorsPanelContainer } from '../ColorsPanel/ColorsPanelContainer'
import { MobilePanels, PanelName } from 'stores/DesignStore.types'
import { DesignerDrawer } from '../DesignerDrawer/DesignerDrawer'

const drawerTitle = (shapes: TLShape[], panel?: PanelName) => {
  switch (panel) {
    case 'textStyles':
      return 'Text Adjustments'
    case 'fontFamily':
      return 'Font Family'
    case 'colors':
      return 'Colors'
    default:
      return shapeName({ shapes, useTextContent: true })
  }
}

export const ShapesDrawer = track(
  observer((props: DrawerProps) => {
    const editor = useEditor()
    const { designStore } = useRootStore()
    const shapes = editor.getSelectedShapes()
    const activePanel = designStore?.panel
    const hasActivePanel = activePanel !== undefined && MobilePanels.includes(activePanel?.type)
    const title = drawerTitle(shapes, activePanel?.type)
    const onBack = hasActivePanel ? () => designStore?.closePanel() : undefined
    const onClose = () => {
      editor.selectNone()
    }

    return (
      <DesignerDrawer title={title} onBack={onBack} onClose={onClose} {...props}>
        {!hasActivePanel && <ShapesTab />}
        {activePanel?.type === 'textStyles' && <FontStylesPanel />}
        {activePanel?.type === 'fontFamily' && <FontFamilyPanel />}
        {activePanel?.type === 'colors' && <ColorsPanelContainer />}
      </DesignerDrawer>
    )
  }),
)
ShapesDrawer.displayName = 'ShapesDrawer'
